import { API_COPY_ISIN_MODAL_URL } from "src/constants/urls";
import { IQueryOptions } from "src/lib/tanstack-query/hooks/use-query";
import { useQuery } from "src/lib/tanstack-query/hooks/use-query";
export interface ICopyIsinModalResponse {
    headline1: string;
    description1: string;
    headline2: string;
    description2: string;
    hideModalCheckbox: string;
}

export const useCopyIsinModalQuery = (isOpen: boolean, options?: IQueryOptions<ICopyIsinModalResponse>) =>
    useQuery<ICopyIsinModalResponse>({ url: API_COPY_ISIN_MODAL_URL, enabled: isOpen, ...options });
